/** ATR gate page size requested from the existing queues (their max is 100). */
export const MY_WORK_ATR_PAGE = 100;

/** Items kept per ATR gate before the source is marked truncated. */
export const MY_WORK_ATR_CAP = 200;

/** Window-focus refresh floor. A hidden tab that returns sooner does not refetch. */
export const MY_WORK_REFRESH_MS = 60_000;
